import React from 'react';

const DepartmentCards = () => {
  const departments = [
    {
      name: "Water Resources Department",
      tanks: "1,847",
      image: "/images/wrd-tanks.jpg" // Replace with your actual image path
    },
    {
      name: "Rural Development and Panchayats Raj",
      tanks: "2,156", 
      image: "/images/rd-tanks.jpg" // Replace with your actual image path
    },
    {
      name: "Town Panchayats",
      tanks: "894",
      image: "/images/tp-tanks.jpg" // Replace with your actual image path
    },
    {
      name: "Greater Chennai Corporation",
      tanks: "156",
      image: "/images/gcc-tanks.jpg" // Replace with your actual image path
    },
    {
      name: "Municipal Administration", 
      tanks: "743",
      image: "/images/ma-tanks.jpg" // Replace with your actual image path
    },
    {
      name: "Hindu Religious Charitable",
      tanks: "1,234",
      image: "/images/hrce-tanks.jpg" // Replace with your actual image path
    },
    {
      name: "Environment, Climate Change & Forest",
      tanks: "2,463",
      image: "/images/forest-tanks.jpg" // Replace with your actual image path
    }
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
        
        .dept-font {
          font-family: 'Inter', system-ui, sans-serif;
        }
        
        .card-hover {
          transition: all 0.3s ease;
        }
        
        .card-hover:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
        }
        
        .gradient-bg {
          background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 50%, #cbd5e1 100%);
        }
      `}</style>
      
      <section className="py-20 gradient-bg dept-font">
        <div className="container mx-auto px-8 max-w-7xl">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-light text-slate-800 mb-6 leading-tight">
              Stakeholder 
              <span className="font-semibold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent"> Departments</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-400 to-indigo-400 mx-auto mb-6 rounded-full"></div>
            <p className="text-xl text-slate-600 font-light max-w-3xl mx-auto leading-relaxed">
              Government departments managing water resources across Tamil Nadu
            </p>
          </div>

          {/* Department Cards Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {departments.map((dept, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden card-hover border border-gray-100">
                {/* Image */}
                <div className="h-48 bg-gradient-to-br from-gray-100 to-gray-200 overflow-hidden flex items-center justify-center">
                  <div className="text-center p-6">
                    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                      <svg className="w-8 h-8 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 0h8v12H6V4z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <div className="text-sm text-gray-600 font-medium">
                      Department Logo<br />Comes Here
                    </div>
                  </div>
                </div>
                
                {/* Content */}
                <div className="p-6">
                  <h3 className="text-lg font-semibold text-slate-800 mb-3 leading-tight">
                    {dept.name}
                  </h3>
                  <div className="text-sm text-slate-600 mb-4">
                    No of Water Bodies: <span className="font-semibold text-blue-600">{dept.tanks}</span>
                  </div>
                  <button className="w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white py-3 px-4 rounded-lg hover:from-blue-600 hover:to-blue-700 transition-all duration-200 font-medium text-sm shadow-md hover:shadow-lg">
                    Know More →
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default DepartmentCards;